import React from 'react'
import { PiQuestionBold } from 'react-icons/pi'
import { FloatingPopover } from './FloatingPopover'
import { ITooltip, Tooltip } from './tooltip'

interface HelpTooltipProps {
  content?: ITooltip['content']
  title?: string
  link?: {
    text?: string
    href?: string
  }
  /** @deprecated delay is ignored by the new tooltip/popover — kept for backward compat */
  delay?: ITooltip['delay']
  icon?: React.JSX.Element
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

const DEFAULT_ICON = (
  <span
    data-help-icon
    className="inline-flex items-center justify-center rounded p-[2px] !text-[#9ca3af] transition-colors duration-100 hover:bg-[#f3f4f6] hover:!text-[#6b7280] focus:bg-[#f3f4f6] focus:outline-none focus:ring-1 focus:ring-[rgba(8,116,67,0.2)]"
  >
    <PiQuestionBold size={14} />
  </span>
)

export function HelpTooltip({
  content,
  title,
  link,
  icon,
  placement,
}: HelpTooltipProps) {
  if (!content) return null

  const trigger = icon ?? DEFAULT_ICON

  // JSX content → fall back to legacy tooltip (new components accept strings only)
  if (typeof content !== 'string') {
    return (
      <Tooltip
        content={content}
        title={title}
        link={link as ITooltip['link']}
        placement={placement}
      >
        <div>{trigger}</div>
      </Tooltip>
    )
  }

  return (
    <FloatingPopover
      description={content}
      title={title}
      link={link}
      placement={placement ?? 'bottom'}
    >
      {trigger}
    </FloatingPopover>
  )
}
